module.exports = __webpack_public_path__ + "static/media/banner01.c2a4796c.png";